import {createContext, useContext, useEffect, useState} from "react";

const DimensionCardsProviderContext = createContext(undefined)

// -- Tipi per le dimensioni --

// Dimensione delle card
export const DimensionCardsMulti = {
    'SMALL' : 1,
    'MEDIUM' : 1.25,
    'LARGE': 1.5
}

export const DimensionScreenMulti = {
    'FHD': {multiplier: 1, boundary_res: 2260},
    'QHD': {multiplier: 1.3, boundary_res: 2260},
    'FK': {multiplier: 1.6, boundary_res: 3440}
}

export function getDimensionScreenCards(innerWidth) {
    if(innerWidth < DimensionScreenMulti.FHD.boundary_res) return DimensionScreenMulti.FHD
    if((innerWidth >= DimensionScreenMulti.FHD.boundary_res) && (innerWidth < DimensionScreenMulti.FK.boundary_res)) return DimensionScreenMulti.QHD
    if(innerWidth >= DimensionScreenMulti.FK.boundary_res) {
        return DimensionScreenMulti.FK
    }
}

export function getGlobalPageSize() {
    const dimension = getDimensionScreenCards(window.innerWidth)
    return Math.ceil(6 * dimension.multiplier);
}

const DimensionCardProv = ({children}) => {
    const [dimensionCard, setDimensionCard] = useState(DimensionCardsMulti.SMALL)
    const [pageSize, setPageSize] = useState(6)

    useEffect(() => {
        setPageSize(getGlobalPageSize())
    }, [])

    useEffect(() => {
        const dimensionScreenCards = getDimensionScreenCards(window.innerWidth)
        if(dimensionScreenCards === DimensionScreenMulti.FK)
            setDimensionCard(() => DimensionCardsMulti.LARGE)
    }, [window.innerWidth]);

    return (
        <DimensionCardsProviderContext.Provider value={{dimensionCard, setDimensionCard, pageSize}}>
            {children}
        </DimensionCardsProviderContext.Provider>
    )
}

const useDimensionCardProvider = () => {
    const context = useContext(DimensionCardsProviderContext)
    if (context === undefined) {
        throw new Error('DimensionCardProvider must be used correctly')
    }
    return context
}

export {DimensionCardProv, useDimensionCardProvider}